<button
  hlmBtn
  variant="ghost"
  size="icon-sm"
  type="button"
  [attr.aria-label]="'menu.sapToken' | translate"
  [hlmTooltip]="tooltip()"
  (click)="generateSamlAssertion()"
  data-cy="sap-token-button">
  <ng-icon
    name="lucideKeyRound"
    [class]="isTokenValid() ? 'text-green-700 dark:text-green-400' : 'text-destructive'" />
</button>
